import "./src/styles/lora-v16-latin/font-face.css";
import "./src/styles/global.css";
